import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Sidebar } from 'primereact/sidebar';
import { useEffect, useState } from 'react';
import FormInput from '../../../../components/Form/FormInput';

function DistributionManager({ isOpen, onClose, distribution, updateDistribution }) {
  const [role, setRole] = useState(distribution?.role);
  const [alias, setAlias] = useState(distribution?.alias);

  useEffect(() => {
    if (!distribution) return;
    setRole(distribution.role);
    setAlias(distribution.alias);
  }, [distribution]);

  const formIsValid = () => {
    return role && alias;
  };

  const onValidate = () => {
    const payload = {
      alias,
      role
    };

    updateDistribution(payload);
  };

  const footerButtons = (
    <div className="manager-footer">
      <Button
        key={'validate'}
        label={'Modifier la distribution'}
        disabled={!formIsValid()}
        onClick={onValidate}
        severity="success"
        className="w-full"
      />
    </div>
  );

  return (
    <Sidebar
      style={{ width: 600 }}
      visible={isOpen}
      position="right"
      onHide={() => onClose(false)}
      header={
        <h3 className="text-slate-800 text-2xl font-medium">{`Modifier une distribution`}</h3>
      }>
      <div className="sidebar-content-container">
        <div className="manager-form-wrapper">
          <div className="flex flex-col gap-y-3 mb-5">
            <FormInput label={'Nom & Prénom'} required isValid={alias}>
              <InputText
                value={alias}
                placeholder="Veuillez saisir le nom et le prénom"
                onChange={(e) => setAlias(e.target.value)}
              />
            </FormInput>

            <FormInput key="type" label={'Role'} required isValid={role}>
              <InputText
                value={role}
                placeholder="Veuillez saisir le nom du tag"
                onChange={(e) => setRole(e.target.value)}
              />
            </FormInput>
          </div>
        </div>
        {footerButtons}
      </div>
    </Sidebar>
  );
}

export default DistributionManager;
